export const RETURN_TO_HOME = '/app/trm/dashboard';
